let _cometChatInstance = null;
let _isInitialized = false;

export function initializeCometChatBridge(sdkInstance) {
    if (!sdkInstance) {
        throw new Error('[CometChatBridge] Cannot initialize with null/undefined SDK instance');
    }

    if (_isInitialized) {
        return;
    }

    _cometChatInstance = sdkInstance;
    _isInitialized = true;

    Object.defineProperty(window, 'CometChat', {
        get: function() {
            if (!_cometChatInstance) {
                throw new Error('[CometChatBridge] CometChat SDK not initialized');
            }
            return _cometChatInstance;
        },
        set: function() {
            // Prevent overwriting
        },
        configurable: false,
        enumerable: false
    });
}

export function getCometChatInstance() {
    if (!_cometChatInstance) {
        throw new Error('[CometChatBridge] CometChat SDK not initialized');
    }
    return _cometChatInstance;
}

export function isCometChatBridgeInitialized() {
    return _isInitialized && _cometChatInstance !== null;
}

export function __resetBridgeForTesting() {
    if (process.env.NODE_ENV === 'production') {
        return;
    }
    _cometChatInstance = null;
    _isInitialized = false;
}
